import { FIELDS, PO_FIELDS } from './constants';

const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  // {
  //   field: 'selectcommands',
  //   title: ' ',
  //   cell: 'selectcommands',
  //   headerCell: 'selectCommandsHeader',
  //   sortable: true,
  //   hidden: false,
  //   locked: true,
  //   width: 30,
  // },
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CompanyId',
    field: FIELDS.COMPANY_ID,
    title: ' Company Id',
    label: 'CompanyId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Vendor',
    label: 'CompanyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'sourceId',
    field: FIELDS.SOURCE_ID,
    title: ' Source Id',
    label: 'sourceId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'sourceName',
    field: FIELDS.SOURCE_NAME,
    title: ' Source Name',
    label: 'sourceName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PaymentDate',
    field: FIELDS.PAYMENT_DATE,
    title: ' Payment Date',
    label: 'PaymentDate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PaymentMethodId',
    field: FIELDS.PAYMENT_METHOD_ID,
    title: ' Payment Method Id',
    label: 'PaymentMethodId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'PaymentMethodName',
    field: FIELDS.PAYMENT_METHOD_NAME,
    title: ' Payment Method',
    label: 'PaymentMethodName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReferenceNumber',
    field: FIELDS.REFERENCE_NUMBER,
    title: ' Reference Number',
    label: 'ReferenceNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Amount',
    field: FIELDS.AMOUNT,
    title: ' Amount',
    label: 'Amount',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: ' Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: ' Modified By User Full Name',
    label: 'ModifiedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export const PoDefaultFields = [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: '',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    key: 'pONumber',
    cell: 'navigation',
    field: PO_FIELDS.ID,
    title: 'Id',
    sortable: true,
    hidden: false,
    locked: true,
    width: 100,
  },
  {
    key: 'statusName',
    field: PO_FIELDS.STATUS_NAME,
    title: 'Status',
    label: 'Status',
    sortable: true,
    hidden: false,
    width: 75,
  },
  {
    key: 'poDate',
    cell: 'poDate',
    field: PO_FIELDS.PO_DATE,
    title: 'Purchase Order Date',
    label: 'Purchase Order Date',
    sortable: true,
    hidden: false,
    width: 120,
  },
  {
    key: 'soDate',
    cell: 'soDate',
    field: PO_FIELDS.SO_DATE,
    title: 'Sales Order Date',
    sortable: true,
    hidden: false,
    width: 120,
  },
  {
    key: 'dueDate',
    field: PO_FIELDS.DUE_DATE,
    title: 'Due Date',
    label: 'Due Date',
    cell: 'dueDate',
    sortable: true,
    hidden: false,
    width: 120,
  },
  {
    key: 'trackingNumber',
    field: PO_FIELDS.TRACKING_NUMBER,
    title: 'Tracking No',
    label: 'Tracking No',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'companyName',
    field: PO_FIELDS.COMPANY_NAME,
    title: 'Company Name',
    label: 'Company Name',
    sortable: true,
    hidden: true,
    width: 300,
  },
  {
    key: 'contactFullName',
    field: PO_FIELDS.CONTACT_FULL_NAME,
    title: 'Contact',
    label: 'Contact',
    sortable: true,
    hidden: true,
    width: 125,
  },
  {
    field: PO_FIELDS.PURCHASING_FOR,
    title: 'Purchasing For',
    label: 'Purchasing For',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: PO_FIELDS.PURCHASER,
    title: 'Purchaser',
    label: 'Purchaser',
    sortable: true,
    hidden: true,
    width: 125,
  },
  {
    key: 'salesTypeName',
    field: PO_FIELDS.SALES_TYPE_NAME,
    title: 'Sales Type',
    label: 'Sales Type',
    sortable: true,
    hidden: true,
    width: 75,
  },
  {
    key: 'authorizedByUserFullName',
    field: PO_FIELDS.AUTHORIZED_BY_USER_FULL_NAME,
    title: 'Authorized By',
    label: 'Authorized By',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'dateAuthorized',
    field: PO_FIELDS.DATE_AUTHORIZED,
    title: 'Date Authorized',
    label: 'Date Authorized',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'Aging',
    field: PO_FIELDS.AGING,
    title: 'Aging',
    label: 'Aging',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'shippingMethodName',
    field: PO_FIELDS.SHIPPING_METHOD_NAME,
    title: 'Ship Via',
    label: 'Ship Via',
    sortable: true,
    hidden: true,
    width: 250,
  },
  {
    key: 'shippingDays',
    field: PO_FIELDS.SHIPPING_DAYS,
    title: 'Ship Days',
    label: 'Ship Days',
    sortable: true,
    hidden: true,
    width: 75,
  },
  {
    key: 'shippingAccount',
    field: PO_FIELDS.SHIPPING_ACCOUNT_NUMBER,
    title: 'Ship Acct',
    label: 'Ship Acct',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'isPaid',
    field: PO_FIELDS.IS_PAID,
    title: 'Paid',
    label: 'Paid',
    sortable: true,
    hidden: true,
    width: 50,
  },
  {
    key: 'onHold',
    field: PO_FIELDS.ON_HOLD,
    title: 'On Hold',
    label: 'On Hold',
    sortable: true,
    hidden: true,
    width: 50,
  },
  {
    key: 'billingTermName',
    field: PO_FIELDS.BILLING_TERM_NAME,
    title: 'Bill Terms',
    label: 'Bill Terms',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'currencyTypeName',
    field: PO_FIELDS.CURRENCY_TYPE_NAME,
    title: 'Currency',
    label: 'Currency',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'exchangeRate',
    field: PO_FIELDS.EXCHANGE_RATE,
    title: 'Exchg Rate',
    label: 'Exchg Rate',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'lineCount',
    field: PO_FIELDS.LINE_COUNT,
    title: 'Line Count',
    label: 'Line Count',
    sortable: true,
    hidden: true,
    width: 75,
  },
  {
    key: 'total',
    field: PO_FIELDS.TOTAL,
    title: 'Total',
    label: 'Total',
    cell: 'total',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'balance',
    field: PO_FIELDS.BALANCE,
    title: 'Balance',
    label: 'Balance',
    cell: 'balance',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'convertedCost',
    field: PO_FIELDS.CONVERTED_COST,
    title: 'Converted Cost',
    label: 'Converted Cost',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'vendorTax',
    field: PO_FIELDS.VENDOR_TAX,
    title: 'Vendor Tax',
    label: 'Vendor Tax',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'vendorShippingCharge',
    field: PO_FIELDS.VENDOR_SHIPPING_CHARGE,
    title: 'Vendor Ship Charge',
    label: 'Vendor Ship Charge',
    sortable: true,
    hidden: true,
    width: 130,
  },
  {
    key: 'createdByUserFullName',
    field: PO_FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Created By',
    label: 'Created By',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'dateCreated',
    field: PO_FIELDS.DATE_CREATED,
    title: 'Date Created',
    label: 'Date Created',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'modifiedByUserFullName',
    field: PO_FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: 'Modified By',
    label: 'Modified By',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'dateModified',
    field: PO_FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    label: 'Date Modified',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'active',
    field: PO_FIELDS.ACTIVE,
    title: 'Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 70,
  },
  // {
  //   field: 'deletecommands',
  //   title: ' ',
  //   cell: 'deletecommands',
  //   headerCell: 'commandsHeader',
  //   sortable: true,
  //   hidden: true,
  //   locked: true,
  //   width: 30,
  // },
  {
    key: 'amount',
    field: 'editamount',
    title: 'Amount',
    label: 'Amount',
    cell: 'editamount',
    sortable: true,
    hidden: false,
    width: 100,
  },
]

export default defaultFields;
